/* CATEDO V3 — page collection : le menu de tri natif devient des onglets.
   Additif : si le script ne tourne pas, le menu deroulant reste en place. */
(function () {
  function CS(k, fr) { return (window.CatedoStrings && window.CatedoStrings[k]) || fr; }
  /* Les libelles viennent des reglages de la section. Rien n'est ecrit ici. */
  function cfg() {
    return document.querySelector('.cv3-cfg') || { dataset: {}, getAttribute: function () { return null; } };
  }

  function poser() {
    var sel = document.getElementById('SortBy');
    if (!sel) return;
    var champ = sel.closest('.facet-filters__field');
    if (!champ) return;
    var barre0 = sel.closest('.facets-container');
    /* Le theme recharge la barre en ajax apres chaque tri : le select est neuf,
       nos onglets ne le sont pas. Sans ce menage, une rangee s'ajoutait a chaque
       clic. On ne refait rien tant qu'il y a exactement un jeu d'onglets. */
    var deja = (barre0 || document).querySelectorAll('.cv3-tri');
    if (sel.dataset.cv3 === '1' && deja.length === 1) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cv3-tri'), function (x) {
      x.parentNode && x.parentNode.removeChild(x);
    });

    var c = cfg();
    if (c.getAttribute('data-tri') === 'false') return;
    var voulus = ['manual', 'best-selling', 'price-ascending', 'price-descending'];
    /* le libelle du reglage, sinon celui que Shopify a mis dans le menu natif */
    function libelle(v) {
      var perso = c.getAttribute('data-' + v);
      if (perso) return perso;
      var o = Array.prototype.find.call(sel.options, function (x) { return x.value === v; });
      return o ? o.textContent.trim() : v;
    }
    var dispo = voulus.filter(function (v) {
      return Array.prototype.some.call(sel.options, function (o) { return o.value === v; });
    });
    if (dispo.length < 2) return;

    /* Quel tri est REELLEMENT applique a l'ecran.
       Le menu natif ne suffit pas : sur une collection rangee par meilleures
       ventes, Shopify y met « most-relevant », qui ne correspond a aucun onglet.
       Resultat mesure le 12.09 : aucun onglet allume au chargement, et le clic
       sur « Meilleures ventes » ne changeait rien puisque c'etait deja l'ordre
       affiche. On lit donc l'url en premier, puis l'ordre de la collection. */
    var choisi = new URL(window.location.href).searchParams.get('sort_by');
    var actuel = choisi || c.getAttribute('data-tri-defaut') || sel.value;
    /* « most-relevant » sans recherche donne exactement l'ordre « meilleures
       ventes » (verifie produit par produit sur la collection litiere). */
    if (actuel === 'most-relevant') actuel = 'best-selling';

    var nav = document.createElement('div');
    nav.className = 'cv3-tri';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', CS('sortLabel', 'Trier les produits'));

    dispo.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = libelle(v);
      b.setAttribute('aria-pressed', actuel === v ? 'true' : 'false');
      b.addEventListener('click', function () {
        /* deja affiche : on ne recharge pas la grille pour rien */
        if (actuel === v) return;
        actuel = v;
        sel.value = v;
        /* le temps que la grille revienne (0,5 a 0,8 s mesure), la barre
           montre qu'elle travaille au lieu de paraitre morte */
        nav.setAttribute('data-charge', '1');
        nav.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        /* on laisse d'abord le theme faire son ajax */
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        /* filet de securite : si l'url n'a pas suivi, on recharge proprement */
        setTimeout(function () {
          nav.removeAttribute('data-charge');
          var u = new URL(window.location.href);
          if (u.searchParams.get('sort_by') !== v) {
            u.searchParams.set('sort_by', v);
            u.searchParams.delete('page');
            window.location.assign(u.toString());
          }
        }, 700);
      });
      nav.appendChild(b);
    });

    champ.classList.add('cv3-cache');
    /* la barre elle-meme, pas .facets (que le theme masque sous 750 px) */
    var barre = sel.closest('.facets-container') || champ.parentNode;
    barre.appendChild(nav);
    sel.dataset.cv3 = '1';
    rangerBarre(barre);
  }

  function compteurAGauche() {
    var boite = document.querySelector('.facets-container');
    if (!boite) return;
    var tous = Array.prototype.slice.call(document.querySelectorAll('.product-count'));
    var cpt = tous.find(function (x) { return x.dataset.cv3; })
      || tous.find(function (x) {
           return !x.classList.contains('medium-hide') && !x.classList.contains('large-up-hide');
         })
      || tous.find(function (x) { return x.getBoundingClientRect().width > 0; });
    if (!cpt || cpt.dataset.cv3) return;
    boite.insertBefore(cpt, boite.firstChild);
    cpt.dataset.cv3 = '1';
    habillerCompteur(cpt);
    rangerBarre(boite);
  }

  function rangerBarre(barre) {
    /* le bouton « Filtrer et trier » du theme et la ligne des filtres actifs
       ne servent a rien quand le filtrage est desactive : nos onglets trient.
       Un .js-filter n'existe que s'il y a de vrais filtres. */
    if (!document.querySelector('.facets__form .js-filter')) {
      /* .facets ne porte plus que le menu natif remplace : il occupait 70 px a droite */
      ['.mobile-facets__wrapper', '.active-facets', '.facets'].forEach(function (sel) {
        Array.prototype.forEach.call(barre.querySelectorAll(sel), function (e) {
          e.classList.add('cv3-cache');
        });
      });
    }
    /* un seul compteur : le notre. Le theme en pose un second pour le mobile.
       On n'efface les autres qu'une fois le notre identifie, sinon on efface tout. */
    var tousCpt = barre.querySelectorAll('.product-count[data-cv3]');
    /* apres un tri en ajax, le theme peut en reinjecter un : on garde le premier */
    if (tousCpt.length > 1) {
      Array.prototype.forEach.call(tousCpt, function (e, i) {
        if (i > 0 && e.parentNode) e.parentNode.removeChild(e);
      });
    }
    var mien = barre.querySelector('.product-count[data-cv3]');
    if (mien) {
      Array.prototype.forEach.call(barre.querySelectorAll('.product-count'), function (e) {
        if (e !== mien) e.classList.add('cv3-cache');
      });
    }
  }

  function habillerCompteur(cpt) {
    var c = cfg();
    var modele = c.getAttribute('data-compteur');
    if (modele === '') return;                 /* champ vide : on laisse le texte du theme */
    if (!modele) modele = '[n] [nom]';
    /* le nombre vient de Shopify, jamais d'un comptage maison */
    var n = (cpt.textContent || '').replace(/\s+/g, ' ').trim().match(/\d[\d\s\u00a0]*/);
    if (!n) return;
    var nb = n[0].trim();
    var nom = c.getAttribute('data-nom');
    if (!nom) {
      var h1 = document.querySelector('.cv3ch__h1');
      nom = h1 ? (h1.childNodes[0].textContent || '').trim() : '';
      if (!nom) return;                        /* pas de nom sur : on ne devine pas */
      nom = nom.charAt(0).toLowerCase() + nom.slice(1);
      if (parseInt(nb.replace(/\D/g, ''), 10) > 1) {
        var mots = nom.split(' ');
        if (mots[0].slice(-1) !== 's' && mots[0].slice(-1) !== 'x') mots[0] += 's';
        nom = mots.join(' ');
      }
    }
    cpt.innerHTML = '';
    var b = document.createElement('b');
    b.textContent = modele.replace('[n]', nb).replace('[nom]', nom);
    cpt.className += ' cv3-cpt';
    cpt.appendChild(b);
    var suite = c.getAttribute('data-compteur-suite');
    if (suite) {
      var sp = document.createElement('span');
      sp.textContent = suite;
      cpt.appendChild(sp);
    }
  }

  function nettoyerLesTitres() {
    /* Le theme met en H2 des libelles de service : « Trier par », « Trier »,
       « 4 produits », un H2 vide. Ils polluent le plan lu par Google.
       On les repasse en div, sans toucher au texte ni au style. */
    var zones = [];
    var z1 = document.getElementById('main-collection-filters');
    var z2 = document.getElementById('ProductGridContainer');
    var z3 = document.querySelector('cart-drawer');
    if (z1) zones.push(z1);
    if (z2) zones.push(z2);
    if (z3) zones.push(z3);
    zones.forEach(function (z) {
      Array.prototype.forEach.call(z.querySelectorAll('h2'), function (h) {
        var d = document.createElement('div');
        d.className = h.className;
        d.innerHTML = h.innerHTML;
        if (h.id) d.id = h.id;
        h.parentNode.replaceChild(d, h);
      });
    });
  }

  /* ── raccourcis vers les sections de contenu ────────────────────────
     Construits a partir des vrais titres de la page : rien a saisir, et la
     barre suit automatiquement si une section est ajoutee ou retiree. */
  /* Un titre editorial fait un mauvais raccourci : « Face à une litière... »
     ne dit rien coupe. On nomme la destination par ce qu'elle contient. */
  function libelleCourt(titre) {
    var t = titre.toLowerCase();
    var table = [
      ['compar', CS('anchorComparison', 'Comparatif')],
      ['face à', CS('anchorComparison', 'Comparatif')],
      ['manuelle', CS('anchorComparison', 'Comparatif')],
      ['classique', CS('anchorComparison', 'Comparatif')],
      ['atout', CS('anchorBenefits', 'Bénéfices')],
      ['bénéfic', CS('anchorBenefits', 'Bénéfices')],
      ['fonctionne', CS('anchorHow', 'Fonctionnement')],
      ['comment ça', CS('anchorHow', 'Fonctionnement')],
      ['choisir', CS('anchorGuide', 'Guide')],
      ['guide', CS('anchorGuide', 'Guide')],
      ['question', CS('anchorQuestions', 'Questions')],
      ['avis', CS('anchorReviews', 'Avis')],
      ['disent', CS('anchorReviews', 'Avis')],
      ['ils ont', CS('anchorReviews', 'Avis')],
      /* équivalents anglais des mots-clés ci-dessus */
      ['versus', CS('anchorComparison', 'Comparatif')],
      [' vs ', CS('anchorComparison', 'Comparatif')],
      ['traditional', CS('anchorComparison', 'Comparatif')],
      ['classic', CS('anchorComparison', 'Comparatif')],
      ['strengths', CS('anchorBenefits', 'Bénéfices')],
      ['benefit', CS('anchorBenefits', 'Bénéfices')],
      ['how does', CS('anchorHow', 'Fonctionnement')],
      ['how it works', CS('anchorHow', 'Fonctionnement')],
      ['choos', CS('anchorGuide', 'Guide')],
      ['faq', CS('anchorQuestions', 'Questions')],
      ['review', CS('anchorReviews', 'Avis')],
      ['customers say', CS('anchorReviews', 'Avis')],
      ['they chose', CS('anchorReviews', 'Avis')]
    ];
    for (var i = 0; i < table.length; i++) {
      if (t.indexOf(table[i][0]) > -1) return table[i][1];
    }
    var mots = titre.split(' ');
    return mots.length > 2 ? mots.slice(0, 2).join(' ') : titre;
  }

  function raccourcis() {
    var hero = document.querySelector('.cv3ch');
    if (!hero || hero.getAttribute('data-ancres') !== 'true') return;
    if (document.querySelector('.cv3-anc')) return;
    /* l'identifiant de la section varie d'un gabarit a l'autre : on part de la
       grille elle-meme et on remonte a sa section */
    var pg = document.querySelector('.product-grid');
    var grille = pg ? pg.closest('.shopify-section') : null;
    if (!grille) return;
    var sections = [], n = grille.nextElementSibling;
    while (n) {
      var h = n.querySelector('h2');
      if (h && h.textContent.trim() && n.getBoundingClientRect().height > 120) {
        if (!n.id) n.id = 'sec-' + sections.length;
        sections.push({ id: n.id, titre: h.textContent.replace(/\s+/g, ' ').trim() });
      }
      n = n.nextElementSibling;
    }
    /* le bandeau final n'est pas une destination : il ferme la page */
    if (sections.length > 3) sections = sections.slice(0, sections.length - 1);
    if (sections.length < 3) return;
    var barre = document.createElement('nav');
    barre.className = 'cv3-anc';
    barre.setAttribute('aria-label', hero.getAttribute('data-ancres-titre') || CS('anchorsTitle', 'Aller à'));
    var mot = document.createElement('span');
    mot.textContent = hero.getAttribute('data-ancres-titre') || CS('anchorsTitle', 'Aller à');
    barre.appendChild(mot);
    sections.forEach(function (x) {
      var a = document.createElement('a');
      a.href = '#' + x.id;
      a.textContent = libelleCourt(x.titre);
      a.title = x.titre;
      barre.appendChild(a);
    });
    grille.appendChild(barre);
  }

  /* ── rappel des produits en cours de page ───────────────────────────
     On reprend les cartes deja rendues : aucune requete, et le contenu
     n'est pas duplique dans le code source de la page. */
  function rappelProduits() {
    var hero = document.querySelector('.cv3ch');
    if (!hero || hero.getAttribute('data-rappel') !== 'true') return;
    if (document.querySelector('.cv3-rap')) return;
    var cartes = document.querySelectorAll('.product-grid .cv3pc');
    if (cartes.length < 2) return;
    var cible = null;
    var cherche = (hero.getAttribute('data-rappel-apres') || '').toLowerCase();
    var pg2 = document.querySelector('.product-grid');
    var grille = pg2 ? pg2.closest('.shopify-section') : null;
    var n = grille ? grille.nextElementSibling : null;
    while (n) {
      var h = n.querySelector('h2');
      var t = h ? h.textContent.toLowerCase() : '';
      if (n.getBoundingClientRect().height > 120) {
        if (cherche && t.indexOf(cherche) > -1) { cible = n; break; }
        if (!cherche && !cible) cible = n;
      }
      n = n.nextElementSibling;
    }
    if (!cible) return;
    var bloc = document.createElement('section');
    bloc.className = 'cv3-rap';
    var t = document.createElement('h2');
    t.textContent = hero.getAttribute('data-rappel-titre') || CS('modelsTitle', 'Les modèles de cette page');
    bloc.appendChild(t);
    var liste = document.createElement('div');
    liste.className = 'cv3-rap__l';
    Array.prototype.forEach.call(cartes, function (c) {
      var img = c.querySelector('.cv3pc__im img');
      var nom = c.querySelector('.cv3pc__t');
      var prix = c.querySelector('.cv3pc__p');
      var a = document.createElement('a');
      a.className = 'cv3-rap__c';
      a.href = c.getAttribute('href');
      a.innerHTML =
        (img ? '<span class="cv3-rap__im"><img src="' + img.currentSrc + '" alt="" loading="lazy" decoding="async"></span>' : '')
        + '<span class="cv3-rap__t">' + (nom ? nom.textContent.trim() : '') + '</span>'
        + '<span class="cv3-rap__p">' + (prix ? prix.textContent.trim() : '') + '</span>';
      liste.appendChild(a);
    });
    bloc.appendChild(liste);
    cible.parentNode.insertBefore(bloc, cible.nextSibling);
  }

  /* ── le bouton « Lire les avis clients » du bas de page arbre vise
     #carbre-testimonials, ecrit en dur dans le fichier gele : ce bloc
     n'existe plus. On l'envoie sur la bande d'avis de la page (11.09). ── */
  function lienAvis() {
    var avis = document.querySelector('[id$="__cv3_avis"]');
    if (!avis || document.getElementById('carbre-testimonials')) return;
    document.querySelectorAll('a[href="#carbre-testimonials"]').forEach(function (a) {
      a.setAttribute('href', '#' + avis.id);
    });
  }

  poser();
  compteurAGauche();
  nettoyerLesTitres();
  raccourcis();
  lienAvis();
  if (document.readyState === 'complete') rappelProduits();
  else window.addEventListener('load', rappelProduits);
  document.addEventListener('DOMContentLoaded', function () { poser(); compteurAGauche(); nettoyerLesTitres(); lienAvis(); });
  /* les facettes rechargent la barre en ajax : on repose les onglets */
  document.addEventListener('shopify:section:load', function () { poser(); compteurAGauche(); nettoyerLesTitres(); });
  var obs = new MutationObserver(function () { poser(); compteurAGauche(); nettoyerLesTitres(); });
  var cible = document.getElementById('main-collection-filters');
  if (cible) obs.observe(cible, { childList: true, subtree: true });
})();
